import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import { CREATE_TERM_NEW_RECORD, GET_TERM_NEW_RECORD } from '../actions';

import {
  createTermNewRecordSuccess,
  createTermNewRecordError,
  getTermNewRecordSuccess,
  getTermNewRecordError
} from './actions';
import { getActivityHeadersUpdated } from "../../utils/parentChildActivities";

const CREATE_NEW_RECORD_ERROR = "New record success.";

const createTermNewRecordAsync = async (payload) => {

  try {
    if (payload.newRecord.termRecord.termId > 0) {
      const responseObject = await centralApiAxios.put("terms?id=" + payload.newRecord.termRecord.termId, payload.newRecord.termRecord, getActivityHeadersUpdated(payload));

      return {
        newsItem: responseObject.data,
        termId: responseObject.data.termId,
        trashed: payload.newRecord.termRecord.trashed,
        isNewsItemCreate: !(payload.newRecord.termRecord.termId > 0),
        message: ""
      };
    }
    else {
      const responseObject = await centralApiAxios.post("terms?id=" + payload.newRecord.termRecord.termId, payload.newRecord.termRecord, getActivityHeadersUpdated(payload));

      return {
        newsItem: responseObject.data,
        termId: responseObject.data.termId,
        trashed: payload.newRecord.termRecord.trashed,
        isNewsItemCreate: !(payload.newRecord.termRecord.termId > 0),
        message: ""
      };
    }

  }
  catch (err) {
    // alert(err);
    return {
      message: CREATE_NEW_RECORD_ERROR,
    };
  }
};

function* createTermNewRecord({ payload }) {
  const { history } = payload;
  try {
    const resultReturned = yield call(createTermNewRecordAsync, payload);
    if (!resultReturned.message) {
      yield put(createTermNewRecordSuccess(resultReturned));
      if (resultReturned.isNewsItemCreate) {
        history.push("/app/term-overview/" + resultReturned.termId);
      }
      window.location.reload();
    } else {
      yield put(createTermNewRecordError(resultReturned.message));
    }
  } catch (errorExp) {
    yield put(createTermNewRecordError(CREATE_NEW_RECORD_ERROR));
  }
}

const getTermNewRecordAsync = async (payload) => {

  if (payload.termId == 0) {
    return {
      termRecord: undefined,
      termId: 0,
      message: ""
    };
  }
  try {
    const responseObject = await centralApiAxios.get(`/terms/${payload.termId}?lcid=1033`);
    return {
      termRecord: responseObject.data,
      termId: responseObject.data.termId,
      message: ""
    };
  }
  catch (err) {
    // alert(err);
    return {
      message: CREATE_NEW_RECORD_ERROR,
    };
  }
};

function* getTermNewRecord({ payload }) {
  // const { history } = payload;
  try {
    const resultReturned = yield call(getTermNewRecordAsync, payload);
    if (!resultReturned.message) {
      yield put(getTermNewRecordSuccess(resultReturned));
    } else {
      yield put(getTermNewRecordError(resultReturned.message));
    }
  } catch (errorExp) {
    yield put(getTermNewRecordError(CREATE_NEW_RECORD_ERROR));
  }
}
// eslint-disable-next-line
export function* watchCreateRecords(newRecord) {
  yield takeEvery(CREATE_TERM_NEW_RECORD, createTermNewRecord);
}
// eslint-disable-next-line
export function* watchgetTermNewRecord(newRecord) {
  yield takeEvery(GET_TERM_NEW_RECORD, getTermNewRecord);
}

export default function* rootSaga() {
  yield all([
    fork(watchgetTermNewRecord),
    fork(watchCreateRecords)
  ]);
}
